import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './css/Home.css';
import './css/Contact.css';
import './css/StudentActivity.css';
import './css/Research.css';
import './css/People.css';
import './css/Academics.css';
import './css/CourseList.css';
import './css/CommonPage.css';

ReactDOM.render(
  <React.Fragment>
    <App />
  </React.Fragment>,
  document.getElementById('root')
);